import React from 'react';
import { useTranslate } from '../TranslationText';

/**
 * Reusable submit button with loading spinner and disabled state.
 *
 * @param {boolean} isSubmitting - Shows spinner and disables button when true
 * @param {string}  text - Custom button text (defaults to 'Submit')
 * @param {string}  loadingText - Custom loading text (defaults to 'Submitting...')
 * @param {string}  className - Additional CSS classes
 * @param {object}  style - Additional inline styles
 * @param {boolean} disabled - Extra disabled condition
 */
export default function SubmitButton({
    isSubmitting = false,
    text,
    loadingText,
    className = '',
    style = {},
    disabled = false,
    ...props
}) {
    const { translate } = useTranslate();

    return (
        <button
            type="submit"
            className={`btn btn-danger rounded ${className}`}
            disabled={disabled || isSubmitting}
            style={{ minWidth: 150, height: 38, ...style }}
            {...props}
        >
            {isSubmitting ? (
                <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    {loadingText || translate('web.submitting', 'Submitting...')}
                </>
            ) : (
                <>
                    <i className="fa-solid fa-circle-check me-1"></i>
                    {text || translate('web.submit', 'Submit')}
                </>
            )}
        </button>
    );
}
